<template>
	<!-- 모달팝업_문의확인 -->
	<div id="popupConfirm" class="popup-wrap" hidden>
		<div class="popup popup-type1" role="dialog" aria-labelledby="popupConfirmTitle">
			<div class="blind-area popup-focus dv-ios-only" role="text" :aria-label="$t('gwa.alt.inquiry.wa_label_1')"><!-- IOS접근성 영역자체에 초점처리 --></div>
			<div class="popup-container">
				<div class="popup-header">
					<h3 class="tit-h3">{{ $t('sdp.menu.qna') }}</h3>
				</div>
				<!-- 2024.06.17 송준형 : REQSDP-4717 - PC Mall 웹접근성 심사 결과 대응_2024년 -->
				<div class="popup-body popup-scroll" id="inqPopContent" tabindex="0">
					<div class="para-wrap">
						<!--<p class="para" v-html="$t('sdp.inpuiry.message.pop_text1')"></p>-->
						<!-- [UI기획]PC Website 1:1문의 대응 지연 팝업 문구 안내 건 START - N20200420_06622 : 2020.04.20 송준형 -->
						<!--<p v-if="cntryCode != 'MY'" class="para" v-html="$t('sdp.inpuiry.message.pop_text1')"></p>-->
						<!--<p v-else class="para" v-html="$t('sdp.inpuiry.message.pop_text.covid19.non_member')"></p>-->
						<!-- [UI기획]PC Website 1:1문의 대응 지연 팝업 문구 안내 건 END - N20200420_06622 : 2020.04.20 송준형 -->
						<p class="para" v-html="$t('sdp.inpuiry.message.pop_text1')"></p>
						<div class="bul bul-star">
							<p>{{ $t('sdp.support.message.qnaInfo3') }}</p>
						</div>
					</div>
				</div>
				<div class="popup-footer">
					<div class="btn-wrap">
						<!-- 2024.06.17 송준형 : REQSDP-4717 - PC Mall 웹접근성 심사 결과 대응_2024년 -->
						<button type="button" @click="goLgaccount()" class="btn btn-type2 btn-primary" id="inqPopLoginBtn" :title="$t('gwa.alt.inquiry.wa_title_2')"><span>{{ $t('sdp.menu.gnb.lgaccount') }}</span></button>
						<!-- 2024.06.17 송준형 : REQSDP-4717 - PC Mall 웹접근성 심사 결과 대응_2024년 -->
						<button type="button" @click="retrieveInquiryRegister()" class="btn btn-type2 btn-secondary popup-close" id="inqPopRegBtn" aria-controls="popupConfirm" :title="$t('gwa.alt.inquiry.wa_title_3')"><span>{{ $t('sdp.inpuiry.message.pop_btn1') }}</span></button>
					</div>
				</div>
				<!-- N20190710_04315-PC 웹사이트 1:1문의 화면 이슈(click추) 2019.07.11 김남중 -->
				<!-- 2024.06.14 송준형 : REQSDP-4717 - PC Mall 웹접근성 심사 결과 대응_2024년 -->
				<!--<button type="button" @click="closeDimmer()" class="btn-ico btn-popup-close popup-close" aria-controls="popupConfirm" :title="$t('gwa.alt.inquiry.wa_title_4')"><span><i class="ico ico-close2">{{ $t('gwa.alt.common.wa_label_19') }}</i></span></button>-->
			</div>
		</div>
	</div>
	<!-- //모달팝업_문의확인 -->
</template>

<script>
    import qs from "qs";
    
    export default {
        name: "InquiryConfirmPop",
        data() {
            return {
                cntryCode: _domainCntryCode,
                popupTabYn: "N" // 2024.06.17 송준형 : REQSDP-4717 - PC Mall 웹접근성 심사 결과 대응_2024년
            }
        },
        created() {
        },
        watch: {
        },
        computed: {
        },
        methods: {
            track () {
				console.log('@@@@ track:', this.$router.currentRoute.path);
				this.$ga.page(this.$router.currentRoute.path)
			},
			retrieveInquiryRegister() {
				dimmer.close('dimmer-popup', 0.6); // N20190710_04315-PC 웹사이트 1:1문의 화면 이슈(주석해제) 2019.07.11 김남중
                var param = "?";
                if (typeof this.$store.state.inquiryCateCode1 == 'undefined') {
                } else {
                    param += `cateCode1=${this.$store.state.inquiryCateCode1}`;
                }
                if (typeof this.$store.state.inquiryCateCode2 == 'undefined') {
                } else {
                    param += `&cateCode2=${this.$store.state.inquiryCateCode2}`;
                }
                if (typeof this.$store.state.inquiryCateCode3 == 'undefined') {
                } else {
                    param += `&cateCode3=${this.$store.state.inquiryCateCode3}`;
                }
                param += "&confirmPopYn=Y"; // 2024.06.18 송준형 : REQSDP-4717 - PC Mall 웹접근성 심사 결과 대응_2024년
                const r = { path : `/main/inquiry/register`+param};
                this.$router.push(r);
			},
            goLgaccount() {
				dimmer.close('dimmer-popup', 0.6); // N20190710_04315-PC 웹사이트 1:1문의 화면 이슈(close추가) 2019.07.11 김남중
                console.log('goLgaccount');

                // 2024.12.17 송준형 : REQSDP-6333 - PCMall LMP(멤버스) 로그인 연동 방식 개선 개발
                var loginPath = "inquiry/register";
                const r = { path : "/main/loginLink?path=" + loginPath };
                this.$router.push(r);
            },
            closeDimmer() {
            	// N20190710_04315-PC 웹사이트 1:1문의 화면 이슈(1:1문의-closeDimmer Method 추가) 2019.07.11 김남중
				console.log('closeDimmer');
				dimmer.close('dimmer-popup', 0.6);
				//alert('==== Current track:['+this.$router.currentRoute.path+'] ====');
				// 이전 페이지 이동
				this.$router.go(-1);
            }
        },
        mounted() {
        	//start- C20190819_65828 : 2019.08.22 김남중 - PC Website Main Promotion Banner 링크 오류 수정 
        	//                         ESC키 처리 및 "this.$router.go(-1);"반복 처리시 "페이지연결불가"퇴어 push(r)로 변경(ESC와 "X"의 closeDimmer()메서드와 좀 다른 성격이다) 
        	document.body.addEventListener('keyup', e => {
       	        if (e.keyCode === 27) {
       	        	dimmer.close('dimmer-popup', 0.6);
       	        	// 이전 페이지 이동
       	        	const r = { path : `/main`};
                    this.$router.push(r);
       	        }
       	    });
        	//end- C20190819_65828 : 2019.08.22 김남중 - PC Website Main Promotion Banner 링크 오류 수정

            // start-2024.06.17 송준형 : REQSDP-4717 - PC Mall 웹접근성 심사 결과 대응_2024년
			const tabKeyDownEventHandler = (e) => {
			    if(e.keyCode == 9 && $(":focus").attr("id") == "inqPopRegBtn") {
			        this.popupTabYn = "Y";
				}
			};
            const tabKeyUpEventHandler = (e) => {
                if(e.keyCode == 9 && this.popupTabYn == "Y") {
                    setFocusScroll('#inqPopContent');
                    this.popupTabYn = "N";
                }
            };

			document.body.addEventListener('keydown', tabKeyDownEventHandler);
            document.body.addEventListener('keyup', tabKeyUpEventHandler);

			$("#inqPopRegBtn").on("click", function(){
                this.popupTabYn = "N";
			    document.body.removeEventListener('keydown', tabKeyDownEventHandler);
                document.body.removeEventListener('keyup', tabKeyUpEventHandler);
			});
            // end-2024.06.17 송준형 : REQSDP-4717 - PC Mall 웹접근성 심사 결과 대응_2024년
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
